import {
  Avatar,
  Divider,
  Flex,
  IconButton,
  Text,
  Tooltip,
  useDisclosure,
  useTheme,
} from '@chakra-ui/react';

import { Fragment } from 'react';
import RowList from '../../nesting/RowList';
import { useTeamTableContext } from '../../context/TeamTableContext';
import TeamEditModal from '../../TeamEditModal';
import { BookMarkIcon, Calendar, Clock, EditPencilIcon } from '../../../icons';
import { truncateText } from '../../../shared/utils';
import { handleTeamSettingsModalProps } from '../../teamTableTypes';
import { StyledLink } from '../../../StyledLink';
import { getRole, UserRole } from '@devd-client/api';
import { TeamDto } from '../../types/team-table.types';
export default function TeamCell({
  cellData,
  subRows,
  level,
  handleTeamSettingsModal,
}: {
  level: number;
  cellData: TeamDto;
  subRows: TeamDto[];
  handleTeamSettingsModal?: handleTeamSettingsModalProps;
}) {
  const { colors } = useTheme();
  const { expanded } = useTeamTableContext();
  const teamModal = useDisclosure();
  return (
    <>
      <Fragment>
        <Flex
          direction="column"
          align="flex-start"
          minH="184px"
          w="full"
          pl={4}
          borderLeft="1px solid #E0E0E0"
          borderRight="1px solid #E0E0E0"
          bg="white"
        >
          <Flex align={'center'} w={'full'} mt={2}>
            <Avatar size={'xs'} name={cellData.name} />
            <StyledLink path={`/teams/${cellData.name}`}>
              <Text
                fontSize={'sm'}
                ml={2}
                fontWeight={'medium'}
                color={'text.gray.300'}
                textDecoration={'underline'}
              >
                {cellData.name}
              </Text>
            </StyledLink>
            {getRole() !== UserRole.EMPLOYEE && (
              <Tooltip label="Edit Team" hasArrow>
                <IconButton
                  ml={'auto'}
                  size={'xs'}
                  variant={'unstyled'}
                  display={'flex'}
                  justifyItems={'center'}
                  pl={0}
                  pr={0}
                  aria-label="expand"
                  icon={<EditPencilIcon />}
                  bg={'transparent'}
                  onClick={() => {
                    handleTeamSettingsModal?.onOpen();
                    teamModal.onOpen();
                  }}
                />
              </Tooltip>
            )}
          </Flex>
          <Tooltip
            label={
              cellData.description?.length > 34 ? cellData.description : ''
            }
            hasArrow
          >
            {cellData.description ? (
              <Text my={3} fontSize={'sm'} color={colors.text.secondary}>
                {truncateText(cellData.description, 34)}
              </Text>
            ) : (
              <Text
                fontSize="sm"
                fontFamily={'heading'}
                my={3}
                color="text.secondary"
                fontWeight="normal"
              >
                Team has no Description
              </Text>
            )}
          </Tooltip>
          <Flex direction={'column'} gap={1}>
            <Tooltip label="Work Time" hasArrow>
              <Flex gap={1} align={'center'}>
                <Clock />
                {cellData.workingHours ? (
                  <Text fontSize={'sm'} color={colors.text.secondary}>
                    {cellData.workingHours}{' '}
                  </Text>
                ) : (
                  <Text
                    fontSize="sm"
                    fontFamily={'heading'}
                    my={3}
                    color="text.secondary"
                    fontWeight="normal"
                  >
                    Working Hours Not Allocated
                  </Text>
                )}
              </Flex>
            </Tooltip>
            <Tooltip label="Work Days" hasArrow>
              <Flex gap={1} align={'center'}>
                <Calendar width={15} height={15} />

                {cellData.workingDays ? (
                  <Text fontSize={'sm'} color={colors.text.secondary}>
                    {cellData.workingDays}
                    {' wkdays/week'}
                  </Text>
                ) : (
                  <Text
                    fontSize="sm"
                    fontFamily={'heading'}
                    my={3}
                    color="text.secondary"
                    fontWeight="normal"
                  >
                    Working Days Not Allocated
                  </Text>
                )}
              </Flex>
            </Tooltip>
          </Flex>

          {cellData.repoList && cellData.repoList.length > 0 ? (
            <Tooltip
              label={
                <Flex direction={'column'}>
                  {cellData.repoList?.map((item: string) => (
                    <Text key={item}>{item}</Text>
                  ))}
                </Flex>
              }
              hasArrow
            >
              <Flex gap={1} mt={4} align={'center'}>
                <BookMarkIcon />
                <Text fontSize={'sm'} color={colors.text.secondary}>
                  {truncateText(cellData.repoList?.[0], 30)}
                  {cellData.repoList?.length > 1 &&
                    `+${cellData.repoList?.length - 1}`}
                </Text>
              </Flex>
            </Tooltip>
          ) : (
            <Flex gap={1} mt={4} align={'center'}>
              <BookMarkIcon />
              <Text
                fontSize="sm"
                fontFamily={'heading'}
                color="text.secondary"
                fontWeight="normal"
              >
                Team has no Repositories allocated
              </Text>
            </Flex>
          )}
        </Flex>
        <Divider />
      </Fragment>
      {subRows && subRows.length > 0 && expanded.includes(cellData.name) && (
        <RowList colKey="TEAM" rows={subRows} level={level + 1} />
      )}

      {teamModal.isOpen && (
        <TeamEditModal
          {...teamModal}
          teamName={cellData.name}
          handleTeamSettingsModal={handleTeamSettingsModal}
        />
      )}
    </>
  );
}
